export const userQueryKeys = {
  all: ["users"] as const,
  checkMinimalAppVersion: () =>
    [...userQueryKeys.all, "check_minimal_app_version"] as const,
  current: () => [...userQueryKeys.all, "current"] as const,
  contactPersons: () => [...userQueryKeys.all, "contact_persons"] as const,
  groups: () => [...userQueryKeys.all, "groups"] as const,
  progress: () => [...userQueryKeys.all, "progress"] as const,
  filters: () => [...userQueryKeys.all, "filters"] as const,
}
